import { RouterProvider } from 'react-router-dom';

// project import
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
//import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import { LoadingSpinnerProvider } from 'contexts/loading-spinner/loading-spinner-context';
import { NotificationModalProvider } from 'components/worten/notification-modal/NotificationModalContext';
import { ApiFetcherProvider } from 'utils/fetcher/ApiFetcher';
import DevelopmentWarningBar from 'components/DevelopmentWarningBar';


// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

const App = () => {

  //Remove console.log
  
  const debugConsole = process.env.REACT_DEBUG_CONSOLE;
  if (debugConsole && debugConsole.toUpperCase() === "FALSE") {
    console.log = function() {}
    console.table = function() {}
    console.info = function() {}
  }


  //-------------------------------------------
  return (
    <ThemeCustomization>
      <DevelopmentWarningBar />
      <LoadingSpinnerProvider>
      
      <NotificationModalProvider>
        <ApiFetcherProvider>
      {/* <RTLLayout> */}
        <Locales>
          <ScrollTop>
            <AuthProvider>              
              <>
                <Notistack>
                  <RouterProvider 
                    router={router}
                    future={{
                      v7_startTransition: true
                    }}
                  />
                  <Snackbar />
                </Notistack>
              </>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      {/* </RTLLayout> */}
      </ApiFetcherProvider>
      </NotificationModalProvider>
      </LoadingSpinnerProvider>
    </ThemeCustomization>
  );
};

export default App;
